'use client'
import {
  GetNavToSrv,
  NavToSrv,
  useAppShellStore,
} from '@bitechsystems/btappshell'
import {
  Card,
  Grid,
  Group,
  Button,
  Stack,
  Text,
  Title,
  Badge,
  ThemeIcon,
} from '@mantine/core'
import React from 'react'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import {
  FaUserFriends,
  FaUsers,
  FaWhatsapp,
  FaProjectDiagram,
} from 'react-icons/fa'
import { FiExternalLink, FiMail } from 'react-icons/fi'
import { GrContact, GrMoney } from 'react-icons/gr'
import { CgWebsite } from 'react-icons/cg'
import { GiMagicPortal } from 'react-icons/gi'
import { shallow } from 'zustand/shallow'
import { getLinkPath } from '../../../routes/Tools'
import { useHomeStatsQueryData } from './useHomeStatsQueryData'

export const ModulesCard = ({ theme, classes }: any) => {
  const statsData = useHomeStatsQueryData()
  const [programDetail] = useAppShellStore(
    (state) => [state.programDetail],
    shallow
  )

  return (
    <Card shadow={'xs'} mt={'lg'}>
      <Card.Section px={'xl'} py='xs' withBorder>
        <Group grow>
          <Group position='left'>
            <Title weight={600} order={5} color={theme.cardHeaderColor}>
              Modules
            </Title>
            <Button
              compact
              size='xs'
              leftIcon={<AiOutlineInfoCircle />}
              variant='default'
              pr={'xs'}
              component='a'
              href={GetNavToSrv(getLinkPath('training'))}
            >
              Training
            </Button>
          </Group>
          <Group position='right' grow>
            <Text align='right'>
              Version: {(programDetail.version ?? '').substring(0, 7)}
            </Text>
          </Group>
        </Group>
      </Card.Section>

      <Card.Section p={'xs'}>
        <Grid grow p='xs' gutter={'lg'}>
          <Grid.Col span={6} md={4}>
            <Stack spacing={'xs'}>
              <Group align={'flex-start'} noWrap>
                <ThemeIcon>
                  <FaUserFriends />
                </ThemeIcon>
                <Stack spacing={2}>
                  <Group>
                    <Text weight={500} size={12} color={theme?.cardHeaderColor}>
                      Clients
                    </Text>
                    {(statsData.client_totals?.active ?? 0) > 0 &&
                      (statsData.client_totals?.all ?? 0) > 0 && (
                        <Badge variant='filled' radius='xl'>
                          {statsData.client_totals?.active} /{' '}
                          {statsData.client_totals?.all}
                        </Badge>
                      )}
                  </Group>
                  <Text weight={600} size={13} color='dark.4'>
                    Manage and maintain Simplicity Clients
                  </Text>
                  {/* <Text weight={400} size={14} color='dimmed'>
                    It is a long established fact that a reader will be
                    distracted by the readable content of a page when looking at
                    its layout.
                  </Text> */}
                  <Group pt={'xs'} spacing='xs'>
                    <Button
                      compact
                      size='xs'
                      leftIcon={<FiExternalLink />}
                      pr={'xs'}
                      component='a'
                      href={GetNavToSrv(getLinkPath('clients'))}
                    >
                      Open
                    </Button>
                  </Group>
                </Stack>
              </Group>
            </Stack>
          </Grid.Col>
          <Grid.Col span={6} md={4}>
            <Stack spacing={'xs'}>
              <Group align={'flex-start'} noWrap>
                <ThemeIcon color={'orange'}>
                  <FaUsers />
                </ThemeIcon>
                <Stack spacing={2}>
                  <Group>
                    <Text weight={500} size={12} color={theme?.cardHeaderColor}>
                      Leads
                    </Text>
                    {(statsData.client_totals?.leads ?? 0) > 0 && (
                      <Badge variant='filled' radius='xl' color={'orange'}>
                        {statsData.client_totals?.leads}
                      </Badge>
                    )}
                  </Group>

                  <Text weight={600} size={13} color='dark.4'>
                    Manage and maintain Simplicity Leads
                  </Text>
                  {/* <Text weight={400} size={14} color='dimmed'>

                  </Text> */}
                  <Group pt={'xs'} spacing='xs'>
                    <Button
                      compact
                      size='xs'
                      leftIcon={<FiExternalLink />}
                      pr={'xs'}
                      color='orange'
                      component='a'
                      href={GetNavToSrv(getLinkPath('leads'))}
                    >
                      Open
                    </Button>
                  </Group>
                </Stack>
              </Group>
            </Stack>
          </Grid.Col>

          <Grid.Col span={6} md={4}>
            <Stack spacing={'xs'}>
              <Group align={'flex-start'} noWrap>
                <ThemeIcon>
                  <FiMail />
                </ThemeIcon>
                <Stack spacing={2}>
                  <Group>
                    <Text weight={500} size={12} color={theme?.cardHeaderColor}>
                      Email
                    </Text>
                    {(statsData.communication?.email ?? 0) > 0 && (
                      <Badge variant='filled' radius='xl'>
                        {statsData.communication?.email}
                      </Badge>
                    )}
                  </Group>

                  <Text weight={600} size={13} color='dark.4'>
                    Simplicity Email Process Client
                  </Text>
                  {/* <Text weight={400} size={14} color='dimmed'>
                    It is a long established fact that a reader will be
                    distracted by the readable content of a page when looking at
                    its layout.
                  </Text> */}
                  <Group pt={'xs'} spacing='xs'>
                    <Button
                      compact
                      component='a'
                      href={GetNavToSrv(getLinkPath('email'))}
                      size='xs'
                      leftIcon={<FiExternalLink />}
                      pr={'xs'}
                    >
                      Open
                    </Button>
                  </Group>
                </Stack>
              </Group>
            </Stack>
          </Grid.Col>
          <Grid.Col span={6} md={4}>
            <Stack spacing={'xs'}>
              <Group align={'flex-start'} noWrap>
                <ThemeIcon color={'green'}>
                  <FaWhatsapp />
                </ThemeIcon>
                <Stack spacing={2}>
                  <Group>
                    <Text weight={500} size={12} color={theme?.cardHeaderColor}>
                      Whatsapp
                    </Text>
                    {(statsData.communication?.whatsapp ?? 0) > 0 && (
                      <Badge variant='filled' radius='xl' color={'green'}>
                        {statsData.communication?.whatsapp}
                      </Badge>
                    )}
                  </Group>

                  <Text weight={600} size={13} color='dark.4'>
                    Whatsapp communications with clients
                  </Text>
                  {/* <Text weight={400} size={14} color='dimmed'>
                    It is a long established fact that a reader will be
                    distracted by the readable content of a page when looking at
                    its layout.
                  </Text> */}
                  <Group pt={'xs'} spacing='xs'>
                    <Button
                      compact
                      size='xs'
                      leftIcon={<FiExternalLink />}
                      pr={'xs'}
                      color='green'
                      onClick={() => {
                        NavToSrv(getLinkPath('whatsapp'))
                      }}
                    >
                      Open
                    </Button>
                  </Group>
                </Stack>
              </Group>
            </Stack>
          </Grid.Col>

          <Grid.Col span={6} md={4}>
            <Stack spacing={'xs'}>
              <Group align={'flex-start'} noWrap>
                <ThemeIcon color={'red'}>
                  <FaProjectDiagram />
                </ThemeIcon>
                <Stack spacing={2}>
                  <Text weight={500} size={12} color={theme?.cardHeaderColor}>
                    Task Actions
                  </Text>
                  <Text weight={600} size={13} color='dark.4'>
                    View Tasks and Actions
                  </Text>
                  {/* <Text weight={400} size={14} color='dimmed'>
                    It is a long established fact that a reader will be
                    distracted by the readable content of a page when looking at
                    its layout.
                  </Text> */}
                  <Group pt={'xs'} spacing='xs'>
                    <Button
                      compact
                      size='xs'
                      leftIcon={<FiExternalLink />}
                      pr={'xs'}
                      color='red'
                      onClick={() => {
                        NavToSrv(getLinkPath('actions'))
                      }}
                    >
                      Open
                    </Button>
                  </Group>
                </Stack>
              </Group>
            </Stack>
          </Grid.Col>
          <Grid.Col span={6} md={4}>
            <Stack spacing={'xs'}>
              <Group align={'flex-start'} noWrap>
                <ThemeIcon color={'dimmed'}>
                  <GrContact />
                </ThemeIcon>
                <Stack spacing={2}>
                  <Text weight={500} size={12} color={theme?.cardHeaderColor}>
                    Contact Persons
                  </Text>
                  <Text weight={600} size={13} color='dark.4'>
                    View Simplicity Contacts
                  </Text>
                  {/* <Text weight={400} size={14} color='dimmed'>
                    It is a long established fact that a reader will be
                    distracted by the readable content of a page when looking at
                    its layout.
                  </Text> */}
                  <Group pt={'xs'} spacing='xs'>
                    <Button
                      compact
                      size='xs'
                      leftIcon={<FiExternalLink />}
                      pr={'xs'}
                      color='gray.7'
                      onClick={() => {
                        NavToSrv(getLinkPath('contactperson'))
                      }}
                    >
                      Open
                    </Button>
                  </Group>
                </Stack>
              </Group>
            </Stack>
          </Grid.Col>

          <Grid.Col span={6} md={4}>
            <Stack spacing={'xs'}>
              <Group align={'flex-start'} noWrap>
                <ThemeIcon color={'dimmed'}>
                  <GrMoney />
                </ThemeIcon>
                <Stack spacing={2}>
                  <Text weight={500} size={12} color={theme?.cardHeaderColor}>
                    Hyphen
                  </Text>
                  <Text weight={600} size={13} color='dark.4'>
                    Payment Distribution Agency
                  </Text>
                  <Text weight={400} size={14} color='dimmed'>
                    Hyphen is a Payment Distribution Agency (PDA) that handles
                    the payments on behalf of Simplicity
                  </Text>

                  <Group pt={'xs'} spacing='xs'>
                    <Button
                      compact
                      size='xs'
                      leftIcon={<CgWebsite />}
                      pr={'xs'}
                      color='gray.7'
                      onClick={() => {
                        NavToSrv(
                          'https://www.hyphenpda.co.za/',
                          undefined,
                          undefined,
                          true
                        )
                      }}
                    >
                      Website
                    </Button>
                    <Button
                      compact
                      size='xs'
                      leftIcon={<GiMagicPortal />}
                      pr={'xs'}
                      color='gray.7'
                      onClick={() => {
                        NavToSrv(
                          'https://portal.hyphen.co.za/hyphenpda/#/login',
                          undefined,
                          undefined,
                          true
                        )
                      }}
                    >
                      Portal
                    </Button>
                  </Group>
                </Stack>
              </Group>
            </Stack>
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  )
}
